import styled from 'styled-components'
import { theme } from '@/client/components'
const { space, breakpoint } = theme

export const NewsList = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: ${space.xl2};
  margin-bottom: ${space.xl4};

  @media (min-width: ${breakpoint.md}) {
    margin-bottom: ${space.xl6};
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: ${breakpoint.lg}) {
    grid-template-columns: repeat(3, 1fr);
  }
`
